module.exports = __webpack_public_path__ + "static/img/8.d374ae0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/sp/8.png
// module id = nTx6
// module chunks = 0